<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import useService from '../../../../Composables/Service/useService.ts'
import type { Service, ServiceLevel } from '../../../../Types/service'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import type FormCreator from '../UI/Form/FormCreator.vue'

const props = defineProps<{
  service: Service
  level: ServiceLevel
  form: InstanceType<typeof FormCreator>
  index: number
}>()

const emit = defineEmits<{
  remove: []
}>()

const { hasStartDate, lastServiceLevel, onlyInitialLevel } = useService(props.service)

const { t, d } = useI18n()
</script>

<template>
  <tr :class="{ 'table-warning': level.terms === 0 }">
    <td class="align-middle col-1" data-test="service-level-form-item-position">
      {{ level.position + 1 }}
    </td>
    <td v-if="hasStartDate" class="align-middle col-2" data-test="service-level-form-item-startAt">
      {{ level.startAt ? d(level.startAt, 'date') : '-' }}
    </td>
    <td class="align-middle col-6">
      <FieldCreator
        v-model="level.amount"
        :form-data="form"
        name="amount"
        collection-name="levels"
        :collection-index="index"
        collection-prototype
        form-ref="myformservice"
        domain="service"
        data-test="service-level-form-item-amount"
      />
    </td>
    <td class="align-middle col-2">
      <FieldCreator
        v-model="level.terms"
        :form-data="form"
        name="terms"
        collection-name="levels"
        :collection-index="index"
        collection-prototype
        :disabled="lastServiceLevel?.position === level.position"
        form-ref="myformservice"
        domain="service"
        data-test="service-level-form-item-terms"
      />
    </td>
    <td class="col-1">
      <div class="d-flex align-items-center">
        <div>
          <ButtonAll
            :title="t('service.action.remove_level')"
            type="danger"
            icon="trash"
            size="small"
            :disabled="onlyInitialLevel"
            e2e-button="removeServiceLevel"
            @click="emit('remove')"
          />
        </div>
        <div class="text-warning">
          <i
            v-if="level.terms === 0"
            class="fa fa-warning fs-16 ml-1/2 mt-3"
            :title="t('service.levelPlannedDeletion')"
          ></i>
        </div>
      </div>
    </td>
  </tr>
</template>
